export default __webpack_public_path__ + "static/media/pdf-thumbnail.76c06983.svg";